export default "__VITE_ASSET__DoGCxXlY__"